import React from "react";

const Home = () => {
  return (
    <main className="bg-[#050810] min-h-screen text-slate-300 font-sans selection:bg-cyan-500/30 relative overflow-hidden">
      {/* 
        Simulated Space Background (Can be replaced with tsParticles later)
        Using CSS radial gradients to create a deep space nebula effect 
      */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-[#1a1145] via-[#050810] to-[#050810] -z-10" />
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 -z-10" />

      <div className="max-w-6xl mx-auto px-6 py-24 space-y-32 relative z-10">
        
        {/* HERO SECTION */}
        <section className="flex flex-col-reverse lg:flex-row items-center gap-12 min-h-[70vh]">
          <div className="lg:w-2/3 space-y-6">
            <p className="text-cyan-400 font-mono tracking-widest uppercase text-sm">
              &gt; System.Initialize()
            </p>
            <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight">
              Rajat <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600">Maurya</span>
            </h1>
            <h2 className="text-2xl md:text-3xl text-slate-400 font-light">
              Senior Software Developer - I
            </h2>
            <p className="text-lg text-slate-400 max-w-2xl leading-relaxed">
              Architecting high-throughput, async-first microservices. Specializing in Python, AWS, and distributed systems handling 1000+ TPS with zero data inconsistency.
            </p>
            <div className="pt-4 flex gap-4">
              <a
                href="#experience"
                className="px-8 py-3 bg-cyan-500/10 border border-cyan-500/50 text-cyan-400 font-mono rounded hover:bg-cyan-500/20 hover:shadow-[0_0_20px_rgba(6,182,212,0.4)] transition-all duration-300"
              >
                View Logs
              </a>
              <a
                href="https://www.linkedin.com/in/rajatmaurya017/"
                target="_blank"
                rel="noreferrer"
                className="px-8 py-3 bg-white/5 border border-white/10 text-white font-mono rounded hover:bg-white/10 transition-all duration-300"
              >
                Establish Link
              </a>
            </div>
          </div>

          {/* Placeholder for future React Three Fiber 3D Object */}
          <div className="lg:w-1/3 flex justify-center relative group perspective-1000">
            <div className="absolute inset-0 bg-cyan-500/20 blur-[100px] rounded-full group-hover:bg-cyan-400/30 transition-all duration-700" />
            <img
              src="https://media.licdn.com/dms/image/v2/D5603AQHYkmclaACRJw/profile-displayphoto-shrink_800_800/B56ZUz7V9CGsAc-/0/1740332950440?e=1749686400&v=beta&t=x25fscI43EiYxPpedmAe6BcL-gMuPuZ0XIamQ83OgJk"
              alt="Rajat Maurya"
              className="w-64 h-64 rounded-2xl object-cover border border-white/10 shadow-[0_0_40px_rgba(0,0,0,0.8)] z-10 grayscale hover:grayscale-0 transition-all duration-500"
              style={{ transform: "rotateY(-10deg) rotateX(10deg)" }} // Fake 3D tilt
            />
          </div>
        </section>

        {/* EXPERIENCE TIMELINE */}
        <section id="experience" className="space-y-12">
          <h2 className="text-3xl font-bold text-white font-mono flex items-center gap-4">
            <span className="text-cyan-500">01.</span> Execution_Trace
          </h2>
          
          <div className="relative border-l border-white/10 ml-4 md:ml-6 space-y-12">
            
            {/* Josh Tech - Senior */}
            <div className="relative pl-8 md:pl-12 group">
              <div className="absolute -left-[5px] top-2 w-2.5 h-2.5 bg-cyan-500 rounded-full shadow-[0_0_10px_rgba(6,182,212,0.8)] group-hover:scale-150 transition-all" />
              <div className="bg-white/[0.02] backdrop-blur-md border border-white/5 p-6 md:p-8 rounded-xl hover:border-cyan-500/30 hover:bg-white/[0.04] transition-all duration-500">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
                  <h3 className="text-xl font-bold text-white">Senior Software Developer</h3>
                  <span className="text-cyan-400 font-mono text-sm">Oct 2024 – Present</span>
                </div>
                <p className="text-slate-400 text-sm mb-4">Josh Technology Group</p>
                <ul className="space-y-3 text-slate-300 text-sm md:text-base">
                  <li className="flex gap-3"><span className="text-blue-500">▹</span> Engineered a multi-tenant Fee Management microservice handling transactions with zero data inconsistency via FastAPI, PostgreSQL, Redis, and AWS.</li>
                  <li className="flex gap-3"><span className="text-blue-500">▹</span> Achieved zero-code-change extensibility for future payment providers, reducing integration time by 80%.</li>
                  <li className="flex gap-3"><span className="text-blue-500">▹</span> Prevented 90% of concurrent data collisions across 10,000+ daily async syncs using PostgreSQL advisory/pessimistic locks.</li>
                </ul>
              </div>
            </div>

            {/* Josh Tech - SDE */}
            <div className="relative pl-8 md:pl-12 group">
              <div className="absolute -left-[5px] top-2 w-2.5 h-2.5 bg-slate-600 rounded-full group-hover:bg-cyan-500 transition-all" />
              <div className="bg-white/[0.02] backdrop-blur-md border border-white/5 p-6 md:p-8 rounded-xl hover:border-cyan-500/30 hover:bg-white/[0.04] transition-all duration-500">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
                  <h3 className="text-xl font-bold text-white">Software Developer</h3>
                  <span className="text-slate-400 font-mono text-sm">Jul 2023 – Sep 2024</span>
                </div>
                <p className="text-slate-400 text-sm mb-4">Josh Technology Group</p>
                <ul className="space-y-3 text-slate-300 text-sm md:text-base">
                  <li className="flex gap-3"><span className="text-blue-500">▹</span> Implemented parallel async requests for signed image URLs, reducing response times by 3–4x.</li>
                  <li className="flex gap-3"><span className="text-blue-500">▹</span> Integrated Redis module caching for Firestore reads, cutting latency by 60%.</li>
                  <li className="flex gap-3"><span className="text-blue-500">▹</span> Built automated data pipelines enforcing PII masking for strict data privacy compliance.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ACHIEVEMENTS (Holographic Cards) */}
        <section className="space-y-12">
          <h2 className="text-3xl font-bold text-white font-mono flex items-center gap-4">
            <span className="text-cyan-500">02.</span> Competitive_Metrics
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            
            {/* Card 1 */}
            <a href="https://codeforces.com/profile/rajat.maurya3423" target="_blank" rel="noreferrer" className="group relative bg-white/[0.02] backdrop-blur-md border border-white/10 p-6 rounded-xl overflow-hidden hover:-translate-y-2 transition-all duration-300 block">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-white group-hover:text-cyan-400 transition-colors">Codeforces</h3>
                <span className="text-2xl">🏆</span>
              </div>
              <p className="text-slate-400">Specialist Rating</p>
            </a>

            {/* Card 2 */}
            <a href="https://www.codechef.com/users/rajat_3435" target="_blank" rel="noreferrer" className="group relative bg-white/[0.02] backdrop-blur-md border border-white/10 p-6 rounded-xl overflow-hidden hover:-translate-y-2 transition-all duration-300 block">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-400 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-white group-hover:text-purple-400 transition-colors">CodeChef</h3>
                <span className="text-2xl">👨‍🍳</span>
              </div>
              <p className="text-slate-400">Max rating 2051 (5-Star)</p>
            </a>

            {/* Card 3 */}
            <div className="group relative bg-white/[0.02] backdrop-blur-md border border-white/10 p-6 rounded-xl overflow-hidden hover:-translate-y-2 transition-all duration-300">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-400 to-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold text-white group-hover:text-green-400 transition-colors">Google Competitions</h3>
                <span className="text-2xl">🌐</span>
              </div>
              <p className="text-slate-400">Top 2000 Kickstart 2021<br/>Rank 3094 Hash Code</p>
            </div>

          </div>
        </section>

        {/* SKILLS TERMINAL */}
        <section className="space-y-12 pb-24">
          <h2 className="text-3xl font-bold text-white font-mono flex items-center gap-4">
            <span className="text-cyan-500">03.</span> Tech_Stack
          </h2>
          <div className="bg-[#0a0e17] border border-white/10 rounded-xl overflow-hidden font-mono text-sm md:text-base">
            <div className="bg-white/5 px-4 py-2 flex items-center gap-2 border-b border-white/10">
              <div className="w-3 h-3 rounded-full bg-red-500" />
              <div className="w-3 h-3 rounded-full bg-yellow-500" />
              <div className="w-3 h-3 rounded-full bg-green-500" />
              <span className="ml-2 text-slate-500 text-xs">rajat@system:~/skills$</span>
            </div>
            <div className="p-6 text-cyan-300 space-y-4">
              <p><span className="text-pink-500">const</span> <span className="text-blue-400">languages</span> = ['Python', 'C++', 'SQL', 'TypeScript', 'JavaScript'];</p>
              <p><span className="text-pink-500">const</span> <span className="text-blue-400">infrastructure</span> = ['AWS', 'GCP', 'Docker', 'PostgreSQL', 'Redis'];</p>
              <p><span className="text-pink-500">const</span> <span className="text-blue-400">frameworks</span> = ['FastAPI', 'Flask', 'React', 'Node.js'];</p>
              <p className="animate-pulse">_</p>
            </div>
          </div>
        </section>
        
      </div>
    </main>
  );
};

export default Home;